(function($) { "use strict";

	$(document).ready(function(){"use strict";
		
		var progressPath = document.querySelector('.progress-wrap path');
		var pathLength = progressPath.getTotalLength();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
		progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		progressPath.style.strokeDashoffset = pathLength;
		progressPath.getBoundingClientRect();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
		var updateProgress = function () {
			var scroll = $(window).scrollTop();
			var height = $(document).height() - $(window).height();
			var progress = pathLength - (scroll * pathLength / height);
			progressPath.style.strokeDashoffset = progress;
		}
		updateProgress();
		$(window).scroll(updateProgress);	
		var offset = 50;
		var duration = 550;
		jQuery(window).on('scroll', function() {
			if (jQuery(this).scrollTop() > offset) {
				jQuery('.progress-wrap').addClass('active-progress');
			} else {
				jQuery('.progress-wrap').removeClass('active-progress');
			}
		});				
		jQuery('.progress-wrap').on('click', function(event) {
			event.preventDefault();
			jQuery('html, body').animate({scrollTop: 0}, duration);
			return false;
		})
		
		
	});
	
})(jQuery);

$(document).ready(function() {
  jQuery('.cart__items-wrapper,.cart__footer-wrapper').wrapAll('<section class="cart-page-sec pb pt"><div class="container"><div class="order-historycontent"></div></div></section>');
  jQuery('.cart-page-section .section-title.main').prependTo('.cart-page-section > .container');
  jQuery('main').insertAfter('header');
  countDownIni('.flip-countdown,.js-flip-countdown'); 
  /********* On scroll heder Sticky *********/
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $("header").addClass("head-sticky");
        $('.announcebar').slideUp('500');
        swiper.autoplay.start();
    } else {
        $("header").removeClass("head-sticky");
        $('.announcebar').slideDown('500');
        swiper.autoplay.start();
    }
  });   
  /********* Mobile Menu ********/  
  $('.mobile-menu-button').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
        $('body').addClass('no-scroll active-menu');
        $(".mobile-menu-wrapper").toggleClass("active-menu");
        $('.overlay').addClass('menu-overlay');
    }, 50);
  }); 
  $('body').on('click','.overlay.menu-overlay, .menu-close-icon svg', function(e){
      e.preventDefault(); 
      $('body').removeClass('no-scroll active-menu');
      $(".mobile-menu-wrapper").removeClass("active-menu");
      $('.overlay').removeClass('menu-overlay');
  });
  /********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no-scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no-scroll');
      $('.overlay').removeClass('active');
    });    
      var $this = $('.collection');
    if ($this.hasClass("collection-leftfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
    var $this = $('.collection');
    if ($this.hasClass("collection-rightfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
  /*********  Header Search Popup  ********/
  $(".search-header a").click(function () {
    $(".search-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(".close-search").click(function () {
    $(".search-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
  /********* Cart Popup ********/
    $('.main-cart').on('click', function (e) {
      $('body').addClass('no-scroll cartOpen');
    });
    $('body').on('click', '.overlay.cart-overlay, .mini-cart-header, .closecart', function (e) {
        $('body').removeClass('no-scroll cartOpen');
    });
    $(".mini-cart-has-item").click(function(event){
      event.stopPropagation();
    });
  /*********  size Popup  ********/ 
    $(".size-btn").click(function() { 
      $(".size-popup").toggleClass("active");   
      $("body").toggleClass("no-scroll");
  });
  $(".close-search").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no-scroll");
  });
  $(".close-btn").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no-scroll");
  });
   /********* category product ********/
  $(".list-view").click(function () {
    $(".list-view").addClass("active");
    $(".grid-view").removeClass("active");

    $(".grid-product .row").removeClass("flex-slider");
    $(".grid-product .row").addClass("product-grid-view");

    jQuery('.product-grid-view > .grid__item').each(function() {
      var prod_img = jQuery(this).find('.product-image-wrapper');
      jQuery(this).find('.product-card-image').insertAfter(prod_img);
      var prod_count = jQuery(this).find('.product-top-content');
      jQuery(this).find('.product-image-top').prependTo(prod_count);
      var new_lbl = jQuery(this).find('.product-bottom-content');
      jQuery(this).find('.wish-lbl-wrp').prependTo(new_lbl);
      var prod_lbl = jQuery(this).find('.rating-content');
      jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_lbl);
    });
  });
  $(".grid-view").click(function () {
    $(".grid-view").addClass("active");
    $(".list-view").removeClass("active");
    
    $(".grid-product .row").removeClass("product-grid-view");

    jQuery('.flex-slider > .grid__item').each(function() {
      var prod_img = jQuery(this).find('.product-image-wrapper');
      jQuery(this).find('.product-card-image').prependTo(prod_img);
      var prod_count = jQuery(this).find('.product-image-wrapper');
      jQuery(this).find('.product-image-top').appendTo(prod_count);
    });
  });
  /******* Subscribe popup Js *******/
  $('.close-sub-btn').click(function () {
    $('.subscribe-popup').slideUp(); 
    $(".subscribe-overlay").removeClass("open");
  });   
  /*********  Multi-level accordion nav  ********/ 
  $('.acnav-label').click(function () {
      var label = $(this);
      var parent = label.parent('.has-children');
      var list = label.siblings('.acnav-list');
      if (parent.hasClass('is-open')) {
          list.slideUp('fast');
          parent.removeClass('is-open');
      }
      else {
          list.slideDown('fast');
          parent.addClass('is-open');
      }
  });  
  /****  TAB Js ****/
  $("ul.tabs li").click(function () {
    var $this = $(this);
    var $theTab = $(this).attr("data-tab");
    if ($this.hasClass("active")) {
    } else {
      $this
        .closest(".tabs-wrapper")
        .find("ul.tabs li, .tabs-container .tab-content")
        .removeClass("active");
      $(
        '.tabs-container .tab-content[id="' +
          $theTab +
          '"], ul.tabs li[data-tab="' +
          $theTab +
          "]"
      ).addClass("active");
    }
    $(this).addClass("active");
  });
 // currency
    function currencyFormSubmit(event) {
        event.target.form.submit();
      }
  
    document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
        element.addEventListener('change', currencyFormSubmit);
      });
  // quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn, .show-qv', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href=$(this).find('a').attr('href')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      var swiper = new Swiper(".qv_slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        speed: 800,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

    });
    $('.quickview-popup').show();
  });

 $('body').on('change', '.nice-select.qv_select__select', function() {
    var variant_price = $(this).find(':selected').data('price');
    $('.qv-price').find('.price-item--regular').text(variant_price);
    
    var variant_img = $(this).find(':selected').data('img');
    var variantImageIndex = $('.qv_slider .qv-pro-slider-img img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
    new Swiper('.qv_slider').slideTo(variantImageIndex);

    var qv_btn = $(this).find(':selected').data('avail');
    if(qv_btn === true ){
      $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
      $('#quick-view-temp .product-form__submit').removeAttr('disabled');
      $('#quick-view-temp .quantity-select').show();
    }else{
      $('#quick-view-temp .product-form__submit').find('span').text('Soldout');
      $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
      $('#quick-view-temp .quantity-select').hide();
    }
    var variant_id = $(this).find(':selected').data('id');
    $('input[name="id"]').val(variant_id);
    });

  // end quickview
  
   // coupan code
    $('body').on('keyup','.discount_coupan', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
    });

  // load-more button scroll
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val()),
      datacollurl = $('[data-coll-url]').val();
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('[data-next-link]').val(datacollurl + "?page="+next_coll);
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.flex-slider, .product-grid-view').append($(responseHTML).find('.flex-slider, .product-grid-view').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

    jQuery('.product-grid-view > .grid__item').each(function() {
      var prod_img = jQuery(this).find('.product-image-wrapper');
      jQuery(this).find('.product-card-image').insertAfter(prod_img);
      var prod_count = jQuery(this).find('.product-top-content');
      jQuery(this).find('.product-image-top').prependTo(prod_count);
      var new_lbl = jQuery(this).find('.product-bottom-content');
      jQuery(this).find('.wish-lbl-wrp').prependTo(new_lbl);
      var prod_lbl = jQuery(this).find('.rating-content');
      jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_lbl);
    });
      
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    

  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-grid-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });
  
    // notify me
  
      $('body').on('click','.notify-btn', function(e) {
          e.preventDefault();
          $('body').addClass('no-scroll notify-active');
          $('.out-of-stock-form,.overlay').addClass('active');
        });
       $('body').on('click','.overlay,.notify-popup-close', function(e) {
          e.preventDefault();
         $('body').removeClass('no-scroll notify-active');
          $('.out-of-stock-form,.overlay').removeClass('active');
        });
  // product slider zoom
    $('.pdp-slider-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });
  
 // sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products_add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products_add-cart-sticky').addClass('show-btn');
        }
    });
    }

    $('body').on('click','.show-btn .sticky-btn', function(e) {
      e.preventDefault();
      $('.cart-btn.product-button').trigger("click");
    });

    $('body').on('click','.products_add-cart-sticky .button', function() {
      var sticky_label = $(this).find('label');
       if(!$(sticky_label).hasClass('sticky-active'))
        {
            $("label.sticky-active").removeClass("sticky-active");
            $(sticky_label).addClass("sticky-active");        
        }

    });


$('.pdp-page-main-sec .button').on('click', function() {
  var selectedRadio = $(this).find('input[type="radio"]:checked');
  
  if (selectedRadio.length > 0) {
    var valueToTrigger = selectedRadio.val();
    $('.products_add-cart-sticky .button input[value="' + valueToTrigger + '"]').click();
  }
});


$('.pdp-page-main-sec .select__select').on('change', function() {
    var selectedValue = $(this).val();
    
    $('.products_add-cart-sticky .select__select option').each(function() {
      if ($(this).val() === selectedValue) {
        $(this).prop('selected', true);
      } else {
        $(this).prop('selected', false);
      }
    });
    // $('.products_add-cart-sticky .select__select').trigger('change');
  });


$('.products_add-cart-sticky .select__select').on('change', function() {
    var selectedValue = $(this).val();
    
    // Find the corresponding option in the first select element and select it
    $('.pdp-page-main-sec .select__select option').each(function() {
      if ($(this).val() === selectedValue) {
        $(this).prop('selected', true);
      } else {
        $(this).prop('selected', false);
      }
    });
  });

// end sticky




  
});  

  /** blog page slider **/
  var swiper = new Swiper(".elegant-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  });
  /** discount slider **/
  $(window).on({
     load: function(){
        $('.swiper--top').trigger('resize');
        let SwiperTop = new Swiper('.swiper--top', {
          spaceBetween: 0,
          centeredSlides: true,
          observer: true,
          observeParents: true,
          speed: 6000,
          autoplay: {
            delay: 1,
          },
          loop: true,
          slidesPerView: 'auto',
          allowTouchMove: false,
          disableOnInteraction: true
        });
      } 
    });


  /*** home banner slider **/
  var swiper = new Swiper(".home-banner-slider", {
    speed: 800,
    loop:true,
    navigation: {
      nextEl: ".home-arrow-next",
      prevEl: ".home-arrow-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  });
  /** bestseller slider **/
  var swiper = new Swiper(".furniture-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: ".fur-tab.swiper-button-next",
      prevEl: ".fur-tab.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** featured-pro-slider **/
  var swiper = new Swiper(".featured-pro-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 800,
    navigation: {
      nextEl: ".fe-pro.swiper-button-next",
      prevEl: ".fe-pro.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** testimonials slider **/
  var swiper = new Swiper(".testimonials-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      formatFractionCurrent: function (number) {
          return '0' + number;
      }
    },  
    navigation: {
      nextEl: ".test-slider.swiper-button-next",
      prevEl: ".test-slider.swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** blog slider **/
   var swiper = new Swiper(".blog-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      formatFractionCurrent: function (number) {
          return '0' + number;
      }
    },  
    navigation: {
      nextEl: ".art-slider.swiper-button-next",
      prevEl: ".art-slider.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** partnert logo slider **/
  var swiper = new Swiper(".partner-logo-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    speed: 800,
    navigation: {
      nextEl: ".brand-logo.swiper-button-next",
      prevEl: ".brand-logo.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** view slider **/
  var swiper = new Swiper(".view-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** pdp-thumb-slider **/
 var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-left")) {
    var galleryThumbs = new Swiper(".gallery-thumbs-left", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: "vertical",  
      breakpoints: {
        992: {
          direction: 'vertical', 
        },
        768: {
          direction: 'horizontal', 
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal', 
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal', 
          slidesPerView: 3,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-left", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumbs.slideTo(galleryMain.activeIndex);
    });
  
    galleryThumbs.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumbs.activeIndex);
    });
}
 var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-right")) {
    var galleryThumbs = new Swiper(".gallery-thumbs-right", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: "vertical",  
      breakpoints: {
        992: {
          direction: 'vertical', 
        },
        768: {
          direction: 'horizontal', 
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal', 
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal', 
          slidesPerView: 3,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-right", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumbs.slideTo(galleryMain.activeIndex);
    });
  
    galleryThumbs.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumbs.activeIndex);
    });
}
 var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-center")) {
    var galleryThumbs = new Swiper(".gallery-thumbs-center", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: "horizontal",  
      breakpoints: {
        992: {
          direction: 'horizontal', 
        },
        768: {
          direction: 'horizontal', 
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal', 
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal', 
          slidesPerView: 3,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-center", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumbs.slideTo(galleryMain.activeIndex);
    });
  
    galleryThumbs.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumbs.activeIndex);
    });
}
  var $this = $('.pdp-left-column');
  if ($this.hasClass("product-noslider")) {
    var galleryMain = new Swiper(".gallery-noslider", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
        crossFade: true
      },
    });
  }
  /***product slider */
  var swiper = new Swiper(".product-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
   /** our team slider **/
   var swiper = new Swiper(".our-team-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });

  /**  timer counter **/
  function updateTimer() {
    future = Date.parse("sept 2, 2023 11:30:00");
    now = new Date();
    diff = future - now;

    days = Math.floor(diff / (1000 * 60 * 60 * 24));
    hours = Math.floor(diff / (1000 * 60 * 60));
    mins = Math.floor(diff / (1000 * 60));
    secs = Math.floor(diff / 1000);

    d = days;
    h = hours - days * 24;
    m = mins - hours * 60;
    s = secs - mins * 60;

    document.getElementById("timer")
        innerHTML =
        '<div>' + d + '<span> : </span></div>' +
        '<div>' + h + '<span> : </span></div>' +
        '<div>' + m + '<span> : </span></div>' +
        '<div>' + s + '<span> </span></div>';
  }
  setInterval('updateTimer()', 1000);

  /** foter acnav **/
  $('.acnav-label1').click(function (event) {
    event.preventDefault();
    if(jQuery( window ).width() < 768) {
      var label = $(this);
      var parent = label.parent('.has-children1');
      var list = label.siblings('.acnav-list1');
      if (parent.hasClass('is-open')) {
          list.slideUp('fast');
          parent.removeClass('is-open');
      }
      else {
          list.slideDown('fast');
          parent.addClass('is-open');
      }
    }
  });
  /** counter js **/
  $('.counting').each(function() {
      var $this = $(this),
          countTo = $this.attr('data-count');
      
      $({ countNum: $this.text()}).animate({
        countNum: countTo
      },

      {

        duration: 3000,
        easing:'linear',
        step: function() {
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.text(this.countNum);
        }

      });  
    });
  /********* back to top ********/    
  var btn = $('#button');

  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });
  
  btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });

  /********* mobile stickybar ********/
  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      $(".mobile-stickybar").addClass('show');
    } else {
      $(".mobile-stickybar").removeClass('show');
    }
  });
  
  /********* Wrapper top space ********/
  $(window).on('load resize orientationchange', function() { 
    var header_hright = $('header').outerHeight();
    $('header').next('.wrapper').css('margin-top', header_hright + 'px');  
  }); 

  function responsiveMenu(){
    if(jQuery(window).width() < 768) {
      $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
    }
    else { 
      $('.product-filter-column').prependTo('.product-list-row');
    }
  }
  jQuery(document).ready(function() {
    responsiveMenu();
  });
  jQuery(window).resize(function() {
    responsiveMenu();
  });

  function countDownIni(countdown) {
    $(countdown).each(function () {
      var countdown = $(this);
      var promoperiod;
      if (countdown.attr('data-promoperiod')) {
        promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
      } else if (countdown.attr('data-countdown')) {
        promoperiod = countdown.attr('data-countdown');
      }
      if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
        $(this).addClass('countdown-block');
        countdown.countdown(promoperiod, function (event) {
          // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
          countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
        });
      }
    });
}

// infinit scroll
function initializeAjaxinate(containerSelector) {
  var endlessScroll = new Ajaxinate({
    container: containerSelector,
    pagination: '#collection-Pagination',
    loadingText: '<img src="https://cdn.shopify.com/s/files/1/0751/3771/2446/files/813.gif?v=1692071901" class="infinity-loader">',
    callback: callbackInfiniteScroll
  });
}

function callbackInfiniteScroll() {
  countDownIni('.flip-countdown,.js-flip-countdown');

jQuery('.product-grid-view > .grid__item').each(function() {
      var prod_img = jQuery(this).find('.product-image-wrapper');
      jQuery(this).find('.product-card-image').insertAfter(prod_img);
      var prod_count = jQuery(this).find('.product-top-content');
      jQuery(this).find('.product-image-top').prependTo(prod_count);
      var new_lbl = jQuery(this).find('.product-bottom-content');
      jQuery(this).find('.wish-lbl-wrp').prependTo(new_lbl);
      var prod_lbl = jQuery(this).find('.rating-content');
      jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_lbl);
    });
}

document.addEventListener("DOMContentLoaded", function() {
  initializeAjaxinate('.flex-slider');

  const list_view = document.querySelector(".list-view");
  if(list_view){
      list_view.addEventListener('click', function(event) {
    if (event.target.classList.contains('product-grid-view')) {
      initializeAjaxinate('.product-grid-view');
    }
  });
  }
  
});